import { Typography } from "@stardust-ds/react"
import TrashIcon from "../../../assets/icons/TrashIcon"
import styles from "./index.module.scss"

export default function FileCard(props) {
  const { title, removeFile, isForm = false } = props
  return (
    <div className={styles.fileCardContainer} style={{ backgroundColor: isForm ? "#F2F5F8" : "#ACB4BA" }}>
      <div className={styles.titleCard} >
        <Typography type="h6" color={isForm ? "#3B454F" : "#FFFFFF"}>{title}</Typography>
      </div>
      <TrashIcon fill={isForm ? "#FF3541" : "#FFFFFF"} onClick={() => removeFile()} />
    </div>
  )
}
